// src/App.js
import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import PrivateRoute from "./components/PrivateRoute";
import PublicRoute from "./components/PublicRoute";


// Import all your pages
import HomePageOne from "./pages/HomePageOne";
import HomePageTwo from "./pages/HomePageTwo";
import HomePageThree from "./pages/HomePageThree";
import HomePageFour from "./pages/HomePageFour";
import HomePageFive from "./pages/HomePageFive";
import HomePageSix from "./pages/HomePageSix";
import HomePageSeven from "./pages/HomePageSeven";
import EmailPage from "./pages/EmailPage";
import AddUserPage from "./pages/AddUserPage";
import AlertPage from "./pages/AlertPage";
import AssignRolePage from "./pages/AssignRolePage";
import AvatarPage from "./pages/AvatarPage";
import BadgesPage from "./pages/BadgesPage";
import ButtonPage from "./pages/ButtonPage";
import CalendarMainPage from "./pages/CalendarMainPage";
import CardPage from "./pages/CardPage";
import CarouselPage from "./pages/CarouselPage";
import ChatEmptyPage from "./pages/ChatEmptyPage";
import ChatMessagePage from "./pages/ChatMessagePage";
import ChatProfilePage from "./pages/ChatProfilePage";
import CodeGeneratorNewPage from "./pages/CodeGeneratorNewPage";
import CodeGeneratorPage from "./pages/CodeGeneratorPage";
import ColorsPage from "./pages/ColorsPage";
import ColumnChartPage from "./pages/ColumnChartPage";
import CompanyPage from "./pages/CompanyPage";
import CurrenciesPage from "./pages/CurrenciesPage";
import DropdownPage from "./pages/DropdownPage";
import ErrorPage from "./pages/ErrorPage";
import FaqPage from "./pages/FaqPage";
import ForgotPasswordPage from "./pages/ForgotPasswordPage";
import FormLayoutPage from "./pages/FormLayoutPage";
import FormValidationPage from "./pages/FormValidationPage";
import FormPage from "./pages/FormPage";
import GalleryPage from "./pages/GalleryPage";
import ImageGeneratorPage from "./pages/ImageGeneratorPage";
import ImageUploadPage from "./pages/ImageUploadPage";
import InvoiceAddPage from "./pages/InvoiceAddPage";
import InvoiceEditPage from "./pages/InvoiceEditPage";

import DevicesListPage from "./pages/DevicesListPage";
import AdsListPage from "./pages/AdListPage";

import InvoicePreviewPage from "./pages/InvoicePreviewPage";
import KanbanPage from "./pages/KanbanPage";
import LanguagePage from "./pages/LanguagePage";
import LineChartPage from "./pages/LineChartPage";
import ListPage from "./pages/ListPage";
import MarketplaceDetailsPage from "./pages/MarketplaceDetailsPage";
import MarketplacePage from "./pages/MarketplacePage";
import NotificationAlertPage from "./pages/NotificationAlertPage";
import NotificationPage from "./pages/NotificationPage";
import PaginationPage from "./pages/PaginationPage";
import PaymentGatewayPage from "./pages/PaymentGatewayPage";
import PieChartPage from "./pages/PieChartPage";
import PortfolioPage from "./pages/PortfolioPage";
import PricingPage from "./pages/PricingPage";
import ProgressPage from "./pages/ProgressPage";
import RadioPage from "./pages/RadioPage";
import RoleAccessPage from "./pages/RoleAccessPage";
import OnboardDevicePage from "./pages/OnboardDevicePage";
import PlayAdsPage from "./pages/PlayAdsPage";
import PlayCommericalAdsPage from "./pages/PlayCommericalAdsPage";
import SignInPage from "./pages/SignInPage";
import SignUpPage from "./pages/SignUpPage";
import StarRatingPage from "./pages/StarRatingPage";
import StarredPage from "./pages/StarredPage";
import SwitchPage from "./pages/SwitchPage";
import TableBasicPage from "./pages/TableBasicPage";
import TableDataPage from "./pages/TableDataPage";
import TabsPage from "./pages/TabsPage";
import TagsPage from "./pages/TagsPage";
import TermsConditionPage from "./pages/TermsConditionPage";
import TextGeneratorPage from "./pages/TextGeneratorPage";
import ThemePage from "./pages/ThemePage";
import TooltipPage from "./pages/TooltipPage";
import TypographyPage from "./pages/TypographyPage";
import UsersGridPage from "./pages/UsersGridPage";
import UsersListPage from "./pages/UsersListPage";
import ViewDetailsPage from "./pages/ViewDetailsPage";
import VideoGeneratorPage from "./pages/VideoGeneratorPage";
import VideosPage from "./pages/VideosPage";
import ViewProfilePage from "./pages/ViewProfilePage";
import VoiceGeneratorPage from "./pages/VoiceGeneratorPage";
import WalletPage from "./pages/WalletPage";
import WidgetsPage from "./pages/WidgetsPage";
import WizardPage from "./pages/WizardPage";
import RouteScrollToTop from "./helper/RouteScrollToTop";
import TextGeneratorNewPage from "./pages/TextGeneratorNewPage";

function App() {
  return (
    <AuthProvider> {/* Wrap with AuthProvider */}
      <BrowserRouter>
        <RouteScrollToTop />
        <Routes>
          {/* Public routes */}
          <Route exact path="/sign-in" element={<SignInPage />} />
          <Route exact path="/sign-up" element={<SignUpPage />} />
          <Route exact path="/forgot-password" element={<ForgotPasswordPage />} />

          {/* Protected routes */}
          <Route exact path="/" element={<PrivateRoute element={HomePageOne} />} />
          <Route exact path="/index-2" element={<PrivateRoute element={HomePageTwo} />} />
          <Route exact path="/dashboard" element={<PrivateRoute element={HomePageThree} />} />
          <Route exact path="/index-4" element={<PrivateRoute element={HomePageFour} />} />
          <Route exact path="/index-5" element={<PrivateRoute element={HomePageFive} />} />
          <Route exact path="/index-6" element={<PrivateRoute element={HomePageSix} />} />
          <Route exact path="/index-7" element={<PrivateRoute element={HomePageSeven} />} />

          {/* Example for remaining routes */}
          <Route exact path="/add-user" element={<PrivateRoute element={AddUserPage} />} />
          <Route exact path="/alert" element={<PrivateRoute element={AlertPage} />} />
          <Route exact path="/assign-role" element={<PrivateRoute element={AssignRolePage} />} />
          <Route exact path="/avatar" element={<PrivateRoute element={AvatarPage} />} />
          <Route exact path="/badges" element={<PrivateRoute element={BadgesPage} />} />
          <Route exact path="/button" element={<PrivateRoute element={ButtonPage} />} />
          <Route exact path="/calendar-main" element={<PrivateRoute element={CalendarMainPage} />} />
          <Route exact path="/devices" element={<PrivateRoute element={DevicesListPage} />} />
          <Route exact path="/ads" element={<PrivateRoute element={AdsListPage} />} />
          <Route exact path="/role-access" element={<PrivateRoute element={RoleAccessPage} />} />
          <Route exact path="/onboard-device" element={<PrivateRoute element={OnboardDevicePage} />} />
          <Route exact path="/play-ads" element={<PrivateRoute element={PlayAdsPage} />} />
          <Route exact path="/play-commerical-ads" element={<PrivateRoute element={PlayCommericalAdsPage} />} />



          {/* Add all other routes in a similar manner */}

          {/* Catch-all for 404 */}
          <Route path="*" element={<ErrorPage />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
